import React from 'react';
import { PropTypes } from 'prop-types';

import { OnTruckLogo } from 'refactored/ui/icons';

const PageHeaderTenant = ({ className }) => {
  return (
    <div className={className} data-testid="page_header">
      <div className="logoContainer">
        <OnTruckLogo />
      </div>
    </div>
  );
};

PageHeaderTenant.propTypes = {
  className: PropTypes.string,
};

PageHeaderTenant.defaultProps = {
  className: '',
};

export default PageHeaderTenant;
